import { useParams } from "react-router";
import { Header } from "../../../components/header/header";
import { useEffect, useState } from "react";
import { Button } from "../../../components/button/button";
import { updateUserExp } from "../../../features/userReducer";
import { useDispatch } from "react-redux";
import KnowledgeAPI from "../../../api/KnowledgeAPI";
import Confetti from "react-confetti-boom";
import classNames from "classnames";

import styles from "./knowledgeBaseTestPage.module.css"
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate";
import { HTMLPreview } from "../../../components/htmlPreview/htmlPreview";
import { Separator } from "../../../components/separator/separator";
import { Text } from "../../../components/text/text";

const initialTestData = {
    id: 0,
    name: "",
    rewardExp: 0,
    text: "",
    answerVariants: [],
};

export const KnowledgeBaseTestPage = () => {
    const { categoryId, testId } = useParams();
    const [testData, setTestData] = useState(initialTestData);

    const [selectedItem, setSelectedItem] = useState(null);

    const [loading, setLoading] = useState(false);
    const [correct, setCorrect] = useState(null);
    const [confetti, setConfetti] = useState(false);

    const navigate = useAnimatedNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!categoryId || !testId) return;
        KnowledgeAPI
            .fetchTestById(categoryId, testId)
            .then(res => {
                if (!res.canAnswer) {
                    navigate(`/knowledge/${categoryId}`);
                    return;
                }
                setConfetti(false);
                setTestData(res);
            })
            .catch(() => setTestData(initialTestData));
    }, [categoryId, testId, navigate]);

    const onSubmit = (answerId) => {
        if (correct !== null) {
            navigate(`/knowledge/${categoryId}`);
            return;
        }

        setLoading(true);
        KnowledgeAPI
            .checkTestAnswer(testId, answerId)
            .then(res => {
                setCorrect(res);
                if (res) {
                    setConfetti(true);
                    dispatch(updateUserExp(testData.rewardExp));
                }
            })
            .catch(console.error)
            .finally(() => setLoading(false));
    }

    return (
        <>
            <Header />

            <Text as="h2" variant="body" size={16} className={styles.test_suptitle}>{testData.name}</Text>
            <HTMLPreview className={styles.test_title} content={testData.text} />
            

            <div className={styles.test_answer_variants}>
                {
                    testData.answerVariants.map((text, i) =>
                        <div
                            key={i}
                            className={
                                classNames(
                                    styles.test_answer_variant,
                                    {
                                        [styles.selected]: i === selectedItem,
                                        [styles.success]: correct && i === selectedItem,
                                        [styles.fail]: correct === false && i === selectedItem
                                    }
                                )
                            }
                            onClick={() => (correct === null) && setSelectedItem(prev => prev === i ? null : i)}
                        >
                            <Text as="span" variant="bodyStrong">{text}</Text>
                        </div>
                    )
                }
            </div>

            <Separator />

            <Button
                fixed
                onClick={() => onSubmit(selectedItem)}
                disabled={selectedItem === null || loading}
                text={correct === null ? "Ответить" : "Продолжить"}
            />

            {
                confetti &&
                <>
                    <Confetti
                        x={0} y={1}
                        deg={-80}
                        launchSpeed={1.8}
                        particleCount={100}
                    />
                    <Confetti
                        x={1} y={1}
                        deg={-125}
                        launchSpeed={1.8}
                        particleCount={100}
                    />
                </>
            }
        </>
    )
}
